import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import ConfirmDelete from 'src/components/common/modal/ConfirmDelete';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import DialogCarousel from './dialog/DialogCarousel';

type RowsItemType = {
  index: number;
  img: any;
  checkbox: boolean[];
  handleSetCheckbox: (item: boolean[]) => void;
  handleSetCheckboxParent: (item: boolean) => void;
  imageList: any[]
};

const RowsItem: React.FC<RowsItemType> = (props) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogCarousel, setOpenDialogCarousel] = useState(false);

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    let checkTemp = [...props.checkbox];
    checkTemp[index] = event.target.checked;
    props.handleSetCheckbox(checkTemp);
    const count = checkTemp.filter(Boolean).length;
    if (count === props.checkbox.length) {
      props.handleSetCheckboxParent(true);
    } else {
      props.handleSetCheckboxParent(false);
    }
  };

  const handleCloseConfirmDelete = () => {
    setOpenConfirm(false);
  };

  const handleDeleteClick = (id: number) => {
    setOpenConfirm(true);
    setDeleteId(id);
  };

  const handleDelete = () => {
    setOpenConfirm(false);
    const token = getToken();
    // const formData = new FormData();
    // formData.append('id', deleteId.toString());
    const formData = {
      id: deleteId,
      patientid: '',
      type: 'image'
    }

    try {
      postAPI(`/karte/delete-gadget?token=${token}`, formData).then(
        (res) => {
          if (res.code === 200) {
          }
        }
      );
    } catch (error) {
      console.error('Failed to delete data:', error);
      return;
    }
  };

  const handleImageClick = () => {
    setOpenDialogCarousel(true)
  }

  const handleCloseCarousel = () => {
    setOpenDialogCarousel(false)
  }

  return (
    <>
      <Grid item width={'107px'}>
        <Stack direction={'row'} justifyContent={'flex-end'} spacing={'4px'}>
          <Box
            component={'img'}
            src='/images/icons/ic-edit.svg'
            alt='edit'
            sx={{ cursor: 'pointer' }}
          />
          <Box
            component={'img'}
            src='/images/icons/ic-trash.svg'
            alt='trash'
            sx={{ cursor: 'pointer' }}
            onClick={() => handleDeleteClick(props.img.id)}
          />
        </Stack>
        <Box
          component={'img'}
          src={props.img.preview}
          alt='ic-note'
          width={'80px'}
          height={'70px'}
          onMouseEnter={(event) => handlePopoverOpen(event)}
          onMouseLeave={handlePopoverClose}
          onClick={() => handleImageClick()}
          sx={{ objectFit: 'contain', cursor: 'pointer' }}
        />
        <Popover
          id='mouse-over-popover'
          sx={{
            pointerEvents: 'none',
            '& .MuiPaper-root.MuiPopover-paper': {
              boxShadow: 'none',
              height: '150px',
              overflowY: 'hidden',
            },
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Box
            component='img'
            src={props.img.preview}
            alt='face-patient'
            width={'200px'}
            height={'150px'}
            sx={{ objectFit: 'contain' }}
            border={'4px solid #F3F3F3'}
          ></Box>
        </Popover>
        <Stack>
          <FormControlLabel
            control={
              <Checkbox
                checked={props.checkbox[props.index]}
                onChange={(e) => handleChange(e, props.index)}
              />
            }
            label={props.img.name}
            sx={{
              '& .MuiSvgIcon-root': { fontSize: '18px' },
              '& .MuiTypography-root': {
                fontSize: '14px',
                wordBreak: 'break-word',
              },
              mr: '0px',
            }}
          />
        </Stack>
      </Grid>

      <ConfirmDelete
        openConfirm={openConfirm}
        handleCloseConfirmDelete={handleCloseConfirmDelete}
        handleDelete={handleDelete}
      />

      <DialogCarousel 
        openCarousel={openDialogCarousel}
        handleCloseCarousel={handleCloseCarousel}
        imageList={props.imageList}
      />
    </>
  );
};

export default RowsItem;
